<template>
  <div class="home-page">
    <HeroBanner :banners="banners" />
    <ProductCategorySection :categories="categories" :loading="siteLoading" />
    <DealerCarousel :dealer="dealers[0] || null" :service-provider="serviceProviders[0] || null" />
    <ContactSection />
  </div>
</template>

<script>
import HeroBanner from '../components/HeroBanner.vue'
import ProductCategorySection from '../components/ProductCategorySection.vue'
import DealerCarousel from '../components/DealerCarousel.vue'
import ContactSection from '../components/ContactSection.vue'

export default {
  name: 'HomeView',
  components: { HeroBanner, ProductCategorySection, DealerCarousel, ContactSection },
  computed: {
    banners () { return this.$store.state.banners },
    categories () { return this.$store.state.categories },
    dealers () { return this.$store.state.dealers },
    serviceProviders () { return this.$store.state.serviceProviders },
    siteLoading () { return this.$store.state.siteLoading },
  },
  created () {
    this.$store.dispatch('loadSiteData')
  }
}
</script>
